import { IssueGalleryCard } from './IssueGalleryCard'

import type { GisIssue } from '../../../api/types'
import type { ResolutionTargets } from '../../../lib/resolution-targets'

interface IssuesGalleryGridProps {
  issues: GisIssue[]
  targets: ResolutionTargets
  activeId: string | null
  onOpen: (id: string) => void
  onHover: (id: string | null) => void
  /** Group-by-question: cards show site + department instead of repeating the question. */
  siteMode?: boolean
}

/**
 * The Gallery presentation of the risk-sorted issues: a wrapping GRID of image cards that fills the
 * region (reflows columns to the available width). A card click opens the issue (the gallery modal);
 * `activeId` just highlights the open card.
 */
export function IssuesGalleryGrid({ issues, targets, activeId, onOpen, onHover, siteMode = false }: IssuesGalleryGridProps) {
  return (
    // 210px min column (was 180px): one fewer column per row at typical widths (7 → 6 on a full
    // panel), so each card reads bigger.
    <div className="grid gap-3 p-1 [grid-template-columns:repeat(auto-fill,minmax(210px,1fr))]">
      {issues.map((i) => (
        <IssueGalleryCard
          key={i.id}
          issue={i}
          targets={targets}
          active={activeId === i.id}
          onOpen={() => onOpen(i.id)}
          onHover={onHover}
          siteMode={siteMode}
        />
      ))}
    </div>
  )
}
